export class DependencyDto {
    Entity: string;
    RecordId: number;
    StartAfterDays: number;
}